import classNames from "classnames";
import React, { FC, MouseEventHandler } from "react";

import Icon from "@/components/ui/Icon/Icon";

interface Props {
  label: string;
  selected: boolean;
  type?: "switch" | "button";
  customClass?: string;
  clickHandler: MouseEventHandler;
}
const CurrencyButton: FC<Props> = ({ label, selected, clickHandler, type = "button", customClass = "" }) => {
  return (
    <>
      <button
        type="button"
        className={`flex items-center justify-between py-xs px-s rounded-full ${selected ? "golden-gradient text-black" : "text-gray-70"}`}
        onClick={clickHandler}
      >
        <span className={`text-m ${customClass}`}>{label}</span>
        {selected && type === "button" && <Icon name="check-single" size="20" />}
      </button>
    </>
  );
};
export default CurrencyButton;
